// extracted by mini-css-extract-plugin
export default {"epic":"#00a3ff","ability":"nW","attribute":"nX","attributes":"nY"};